// @flow
import React, { Component } from 'react';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';
import SizeGridTable from './SizeGridTable';
import SizeGridKey from './SizeGridKey';
// import TabbedSizeGrid from './SizeGridTabbed';

type Props = {
  value: string,
  sizes: {
    value: string,
    variants: Array<Sizes>,
  },
  containerWidth: number,
  onChange: () => void,
  sizeType: string,
  // both of the below are anticipatory of further functionality
  // respectStockLevels: ?boolean,
  // isReview: ?boolean,
  selectedSku: Sku,
};

export const messages = defineMessages({
  selected: {
    id: 'size-grid.selected',
    defaultMessage: 'Selected: {value} - {status}',
  },
});

/**
 * @param {Object} sizes
 * @returns {Object} table
 */
const createTable = sizes => {
  const cols = new Set();
  const rows = new Set();
  sizes.variants.forEach(v1 => {
    rows.add(v1.value);
    v1.sizes.variants.forEach(v2 => cols.add(v2.value));
  });
  return {
    cols: Array.from(cols.values()).sort(),
    rows: Array.from(rows.values()),
    items: sizes.variants,
  };
};

class SizeGrid extends Component<Props> {
  state = {
    paginate: false,
    grid: createTable(this.props.sizes),
  };

  /**
   * @param {object} nextProps
   * */
  componentWillReceiveProps(nextProps) {
    /* We are going to check whether the containing element has enough space to display the full grid.
       * If not, we will paginate it (somehow, details to follow)
       * UPDATE: removing this while we are not using the tabbed size grid, it may return but is not required
       * at the present moment
       if (nextProps.containerWidth && this.tableReference) {
         this.shouldTablePaginate(nextProps.containerWidth, this.tableReference.clientWidth);
       }
      */

    // We no longer rely on a server refresh when changing between swatch colours, as a result we need to
    // re-render the grid. Only do it if the sizes object is new, to avoid re-renders on window size change &etc
    if (nextProps.sizes !== this.props.sizes) {
      this.setState({
        grid: createTable(nextProps.sizes),
      });
    }
  }

  setTableRef = ref => {
    this.tableReference = ref;
  };

  /**
   * @param {number} container
   * @param {number} table
   * @returns {*}
   */
  shouldTablePaginate(container, table) {
    return container && container < table
      ? this.setState({ paginate: true })
      : this.setState({ paginate: false });
  }

  /**
   * @returns {XML}
   */
  render() {
    return (
      <section className="c-size-grid__container">
        {!this.state.paginate && (
          <SizeGridTable
            grid={this.state.grid}
            onChange={this.props.onChange}
            setRefOnParent={this.setTableRef}
            selectedSku={this.props.selectedSku}
            sizeType={this.props.sizes.value}
          />
        )}
        {!this.state.paginate && (
          <div>
            <SizeGridKey
              modifiers={['in-stock', 'low-stock', 'pre-order', 'no-stock']}
            />
            {this.props.selectedSku && (
              <div className="c-size-grid__selected">
                <svg viewBox="0 0 16 16">
                  <circle
                    className="c-size-grid__selected__token"
                    cx="50%"
                    cy="50%"
                    r="5"
                    strokeWidth="2"
                  />
                </svg>
                <p className="c-message--inform">
                  <FormattedMessage
                    {...messages.selected}
                    values={{
                      value: this.props.selectedSku.label,
                      status: this.props.selectedSku.stockStatus,
                    }}
                  />
                </p>
              </div>
            )}
          </div>
        )}
      </section>
    );
  }
}

export default injectIntl(SizeGrid);
